import React from 'react';
import {FormattedMessage} from 'react-intl';
import {pathnames as P} from '../../../_common/constants/pathnames';
import {subjects as S} from '../../../_common/constants/permissionSubjects';
import AsideMenuLink from '../../../_common/components/Aside/AsideMenuLink';

const InspectionsMapLink = () => {
  return (
    <AsideMenuLink
      subject={S.INSPECTIONS_MAP_PAGE}
      pathname={P.INSPECTIONS_MAP_PAGE}
      isSubSection={false}
      icon={'Geo_yellow.svg'}
      label={<FormattedMessage id="inspections-map-page-link" defaultMessage="Inspections map"/>}
    />
  );
};

export default InspectionsMapLink;
